<div *ngIf="isAnsMedia && !isMobile1 else QuestionMedia">
  <audio id="{{idKey}}_audio">
    <source src="{{path}}" type="audio/mpeg">
    Sadly, your browser doesn't support audio playback :(
  </audio>

  <div class="container" id="{{idKey}}_circle" (click)="$event.stopPropagation();">
    <div class="svg-wrapper">
      <svg width="105" height="53">
        <g>
          <circle r="24" cx="50" cy="25" class="track"></circle>
          <circle r="24.2" cx="52.9" cy="25"
            [ngClass]="{'progress': circumFurance > 0, 'track-initial': circumFurance == 0}" id="{{idKey}}_progress"
            style="stroke-linecap: round;" [attr.stroke-dashoffset]="strokeDashoffset"
            [attr.stroke-dasharray]="circumFurance"></circle>
        </g>
      </svg>

      <div (click)="backwordAudio();event.stopPropagation();" *ngIf="audioIsPlaying" id="{{idKey}}_backward" class="backward-audio"></div>
      <div (click)="forwordAudio();event.stopPropagation();" *ngIf="audioIsPlaying" id="{{idKey}}_forward" class="forward-audio"></div>
    </div>

    <div class="audio-player" id="{{idKey}}" (click)="playAndPauseAudio();event.stopPropagation();">
      <div class="audio-player-controls">
        <div class="audio-player-button" [ngClass]="{'play-audio': !audioIsPlaying, 'pause-audio': audioIsPlaying, 'play-audio-initial':  circumFurance > 0 && progress1==1, 'play-audio-progress': circumFurance > 0 && progress1!=1}">
        </div>
      </div>
    </div>

    <!-- <div class="audio-details-wrapper">
    <span>{{currentValue}} / {{totalTime()}} </span>
  </div> -->
    <!-- <div (click)="muteAndUnmute()" [ngClass]="{'mute-audio': !isMuted, 'unmute-audio': isMuted}"></div> -->
  </div>
</div>
<ng-template #QuestionMedia>
  <!-- <audio width="100%" [src]="path" controls controlslist="nodownload noplaybackrate noremoteplayback"></audio> -->
  <ng-container *ngIf="isMobile;else Webtimeline">
    <div class="hrz_audio_wrapper"
    (touchend)="mouseUpin()" (touchmove)="mousemove($event)" (touchstart)="drag($event);mousedownin();" id="{{idKey}}_audio_wrapper">
    <!-- <div class="hrz_audio_wrapper" id="{{idKey}}_audio_wrapper"> -->
      <div class="hrz_container" [ngClass]="{'hrz-play': !audioIsPlaying, 'hrz-pause': audioIsPlaying}"
        (click)="audioPlay()"></div>
      <div class="hrz_timer">
        <span>{{currentValue}}</span>
      </div>
      <div id="{{idKey}}_seekObjContainer" class="seekObjContainer">
        <audio id="{{idKey}}_audio">
          <source src="{{path}}" type="audio/mpeg">
          Sadly, your browser doesn't support audio playback :(
        </audio>
        <!-- (mousemove)="isMouseMove ? dragFunc($event) : ''" (mouseover)="isMouseMove ? dragFunc($event) : ''" -->
        <!-- (document:mousedown)="drag($event) (window:mouseup)="mouseUp($event)" (document:mousemove)="dragFunc($event)"" -->
        <!-- <div id="{{idKey}}_audiofill" class="audio_fill" (touchstart)="drag($event)" (touchend)="mouseUp($event)" style="width: 0px;"></div>
        <div id="{{idKey}}_timeline1" class="timeline" (touchstart)="drag($event)" (touchend)="mouseUp($event)" > -->
          <!-- <div id="{{idKey}}_audiofill" class="audio_fill" (click)="seek($event, false)" (mousedown)="drag($event)" (mouseup)="mouseUp($event)" style="width: 0px;"></div>
        <div id="{{idKey}}_timeline1" class="timeline" (click)="seek($event)" (mousedown)="drag($event)" (mouseup)="mouseUp($event)" > -->

          <div id="{{idKey}}_audiofill" class="audio_fill" (touchstart)="drag($event);mousedownin();"
            (touchend)="mouseUp($event);mouseUpin();" style="width: 0px;"></div>
          <div id="{{idKey}}_timeline1" class="timeline" (touchstart)="drag($event);mousedownin();"
            (touchend)="mouseUp($event);mouseUpin();">
            <div id="{{idKey}}_seekObj1" class="playhead seekObj" style="margin-left: 0px;"></div>
          </div>

          <!-- <ng-container *ngIf="isMobile;else Webtimeline1">
            <div id="{{idKey}}_timeline1" class="timeline" (touchstart)="drag($event)" (touchend)="mouseUp($event)"></div>
          </ng-container>
          <ng-template #Webtimeline1>
            <div id="{{idKey}}_timeline1" class="timeline" (click)="seek($event)" (mousedown)="drag($event)"
              (mouseup)="mouseUp($event)"></div>
          </ng-template> -->
          <!-- <div id="{{idKey}}_audiofill" class="audio_fill" style="width: 0px;"></div>
        <div id="{{idKey}}_timeline1" class="timeline" >
          <div id="{{idKey}}_seekObj1" class="playhead seekObj" style="margin-left: 0px;"></div>
        </div> -->
      </div>
    </div>
  </ng-container>
  <ng-template #Webtimeline>
    <div class="hrz_audio_wrapper" (mouseleave)="mouseUpin()"
    (mouseup)="mouseUpin()" (mousemove)="mousemove($event)" id="{{idKey}}_audio_wrapper">
      <div class="hrz_container" [ngClass]="{'hrz-play': !audioIsPlaying, 'hrz-pause': audioIsPlaying}"
        (click)="audioPlay()"></div>
      <div class="hrz_timer">
        <span>{{currentValue}}</span>
      </div>
      <div id="{{idKey}}_seekObjContainer" class="seekObjContainer">
        <audio id="{{idKey}}_audio">
          <source src="{{path}}" type="audio/mpeg">
          Sadly, your browser doesn't support audio playback :(
        </audio>
        <!-- (mousemove)="isMouseMove ? dragFunc($event) : ''" (mouseover)="isMouseMove ? dragFunc($event) : ''" -->
        <!-- (document:mousedown)="drag($event) (window:mouseup)="mouseUp($event)" (document:mousemove)="dragFunc($event)"" -->
        <!-- <div id="{{idKey}}_audiofill" class="audio_fill" (touchstart)="drag($event)" (touchend)="mouseUp($event)" style="width: 0px;"></div>
        <div id="{{idKey}}_timeline1" class="timeline" (touchstart)="drag($event)" (touchend)="mouseUp($event)" > -->
          <!-- <div id="{{idKey}}_audiofill" class="audio_fill" (click)="seek($event, false)" (mousedown)="drag($event)" (mouseup)="mouseUp($event)" style="width: 0px;"></div>
        <div id="{{idKey}}_timeline1" class="timeline" (click)="seek($event)" (mousedown)="drag($event)" (mouseup)="mouseUp($event)" > -->

            <div id="{{idKey}}_audiofill" class="audio_fill" (click)="seek($event, false)" (mousedown)="drag($event);mousedownin();"
              (mouseup)="mouseUp($event);mouseUpin();" style="width: 0px;"></div>
              <div id="{{idKey}}_timeline1" class="timeline" (click)="seek($event)" (mousedown)="drag($event);mousedownin();"
              (mouseup)="mouseUp($event);mouseUpin();">
              <div id="{{idKey}}_seekObj1" class="playhead seekObj" style="margin-left: 0px;"></div>
            </div>
          <!-- <ng-container *ngIf="isMobile;else Webtimeline1">
            <div id="{{idKey}}_timeline1" class="timeline" (touchstart)="drag($event)" (touchend)="mouseUp($event)"></div>
          </ng-container>
          <ng-template #Webtimeline1>
            <div id="{{idKey}}_timeline1" class="timeline" (click)="seek($event)" (mousedown)="drag($event)"
              (mouseup)="mouseUp($event)"></div>
          </ng-template> -->
          <!-- <div id="{{idKey}}_audiofill" class="audio_fill" style="width: 0px;"></div>
        <div id="{{idKey}}_timeline1" class="timeline" >
          <div id="{{idKey}}_seekObj1" class="playhead seekObj" style="margin-left: 0px;"></div>
        </div> -->
      </div>
    </div>
  </ng-template>


</ng-template>
